export default __webpack_public_path__ + "static/media/map1.50da1951.webp";